import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchAssetHierarchy } from "../thunk/MapSliceThunk";

const initialData: any = [];

const AssetHierarchySlice: Slice<any, {}, "AssetHierarchySlice"> = createSlice({
    name: "AssetHierarchySlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchAssetHierarchy.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchAssetHierarchy.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchAssetHierarchy.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default AssetHierarchySlice